import { useUser } from "@clerk/react";
import { Dialog, DialogTitle } from "@mui/material";
import { type FC } from "react";

import { GuestLimitDialogContent } from "~/feature/watchlist/components/WatchlistLimitDialog/components/GuestLimitDialogContent";
import { UserLimitDialogContent } from "~/feature/watchlist/components/WatchlistLimitDialog/components/UserLimitDialogContent";
import { useWatchlist } from "~/feature/watchlist/providers/WatchlistProvider";

interface IWatchlistLimitDialogProps {
  open: boolean;
  onClose: () => void;
}

export const WatchlistLimitDialog: FC<IWatchlistLimitDialogProps> = ({
  open,
  onClose,
}) => {
  const { watchlistLimit } = useWatchlist();
  const { isSignedIn } = useUser();

  const title = isSignedIn
    ? `Plan limit reached (${watchlistLimit} events)`
    : `Free watchlist limit reached (${watchlistLimit} events)`;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      {isSignedIn ? (
        <UserLimitDialogContent onClose={onClose} />
      ) : (
        <GuestLimitDialogContent onClose={onClose} />
      )}
    </Dialog>
  );
};
